module.exports = __webpack_public_path__ + "img/bmw-usa-2x_abf30b1a1daa8e9e644356a5f32aa8f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/bmw-usa-2x.jpg
// module id = 290
// module chunks = 0